import React from 'react';
import { useControl } from 'react-map-gl';
import { MapContextValue } from 'react-map-gl/dist/esm/components/map';
import { MapboxGLButtonControlClass } from './MapboxGLButtonControlClass';
import { ControlPosition } from 'react-map-gl/src/types';

type Props = {
    title: string;
    eventHandler: (event: any) => void;
    position: ControlPosition;
    className?: string;
    icon?: string;
};

const MapControlButton = React.forwardRef(
    ({ title, eventHandler, position, className, icon }: Props, ref) => {
        useControl<any>(
            ({ map }: MapContextValue) => {
                return new MapboxGLButtonControlClass({
                    className,
                    title,
                    icon,
                    eventHandler,
                    ref,
                });
            },
            {
                position,
            }
        );

        return null;
    }
);

export default MapControlButton;
